var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-timer",class:_vm.classes},[_c('span',[_vm._v(_vm._s(_vm.time === 0 || _vm.time >= 10 ? _vm.time : '0'+_vm.time))]),_vm._v(" "),_c('span',[_vm._v("seconds")])])}
var staticRenderFns = []

export { render, staticRenderFns }